import Vue from 'vue'
import App from './App.vue'
import router from './config/router'
import Panel from './components/panel/panel.vue';
import "vue-material-design-icons/styles.css";
import "vue-material-design-icons/styles.css";
import VModal from 'vue-js-modal';
import './config/axios';
import store from './config/store';
import './components/style-global.css';
import "@mdi/font/css/materialdesignicons.min.css";
import carousel from 'vue-owl-carousel';
import VueAWN from "vue-awesome-notifications";
require("vue-awesome-notifications/dist/styles/style.css");
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

let option = {
  position: 'top-right', 
  icons: {
    prefix: "<i class='fa mdi ",
    suffix: "'></i>",
    tip: "mdi-help-circle-outline",
    info: "mdi-information-outline",
    success: 'mdi-check-circle-outline',
    warning: "mdi-alert-circle-outline",
    alert: "mdi-alert",
    async: "mdi-loading mdi-spin",
  },
  durations: {
    global: 4000
  }
}

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

Vue.use(VueAWN, option);

Vue.use(carousel);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

Vue.config.productionTip = false

Vue.use(VModal);

Vue.component('qb-panel', Panel);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
